
















import Vue from 'vue'
import draggable from 'vuedraggable'

export default Vue.extend({
    components: {
        draggable
    },
    props: {
        charts: {
            type: Array,
            required: true
        },
        isEditMode: {
            type: Boolean,
            default: false
        }
    }

})
